export const DEPARTMENT_USER = "Department User";
export const ADMIN = "Admin";
export const SUPER_ADMIN = "Super Admin";
export const READONLY_ADMIN = "Readonly Admin";
